import { isString } from 'lodash-es'

export const isTaxIdError = (errorMessage) => {
  if (!isString(errorMessage)) return false

  const msg = errorMessage.toLowerCase()
  return ['billing_address[country]', 'vat_number'].some((field) => msg.includes(field))
}
